export function updateAttachmentsReducer(state, action) {
    let newState = Object.assign({}, state);
    action.payload.attachmentIds.forEach(id => {
        newState[id] = Object.assign(Object.assign({}, newState[id]), { description: action.payload.description });
    });
    return newState;
}
//# sourceMappingURL=updateAttachmentsReducer.js.map